<template>
  <v-container v-if="superUser || permission" fluid class="b-container">
    <b-announcement
      v-if="announcement.active"
      :color="announcement.color"
      :text-color="announcement.textColor"
    >
      <div v-for="(txt, i) in announcement.texts" :key="i">
        <router-link v-if="txt.href" :to="txt.href" class="b-signin-link"
          ><span style="color: black; text-decoration: underline">{{
            txt.value[lang]
          }}</span></router-link
        >
        <span v-else style="white-space: pre">{{ txt.value[lang] }} </span>
      </div>
      <span style="font-weight: 500" v-if="announcement.description">{{
        `: ${announcement.description[lang]}`
      }}</span>
    </b-announcement>

    <v-col
      v-if="superUser && subscription.expiration_dates"
      class="d-flex flex-row px-0 justify-space-between"
    >
      <v-col v-if="subscription.expiration_dates.store_inactive" cols="12" sm="6" md="3">
        <b-card
          hide-title
          hide-default-footer
          :color="
            isDateExpired(subscription.expiration_dates.store_inactive)
              ? 'error lighten-5'
              : 'grey lighten-4'
          "
          :style="{
            borderLeft: isDateExpired(subscription.expiration_dates.store_inactive)
              ? '4px solid #ff5252'
              : '4px solid #9e9e9e',
          }"
          elevation="3"
          class="pa-2 expiration-card"
        >
          <div
            class="text-caption font-weight-medium mb-1"
            :class="
              isDateExpired(subscription.expiration_dates.store_inactive)
                ? 'error--text'
                : 'grey--text text--darken-2'
            "
          >
            {{ translations.storeInactiveLabel[lang] }}
          </div>
          <div
            class="text-body-1 font-weight-bold"
            :class="
              isDateExpired(subscription.expiration_dates.store_inactive) ? 'error--text' : ''
            "
          >
            {{ formatShortDate(subscription.expiration_dates.store_inactive) }}
          </div>
          <div class="text-caption error--text mt-1">
            <span v-if="isDateExpired(subscription.expiration_dates.store_inactive)">{{
              translations.expired[lang]
            }}</span>
          </div>
        </b-card>
      </v-col>

      <v-col v-if="subscription.expiration_dates.pos_inactive" cols="12" sm="6" md="3">
        <b-card
          hide-title
          hide-default-footer
          :color="
            isDateExpired(subscription.expiration_dates.pos_inactive)
              ? 'error lighten-5'
              : 'grey lighten-4'
          "
          :style="{
            borderLeft: isDateExpired(subscription.expiration_dates.pos_inactive)
              ? '4px solid #ff5252'
              : '4px solid #9e9e9e',
          }"
          elevation="3"
          class="pa-2 expiration-card"
        >
          <div
            class="text-caption font-weight-medium mb-1"
            :class="
              isDateExpired(subscription.expiration_dates.pos_inactive)
                ? 'error--text'
                : 'grey--text text--darken-2'
            "
          >
            {{ translations.posInactiveLabel[lang] }}
          </div>
          <div
            class="text-body-1 font-weight-bold"
            :class="isDateExpired(subscription.expiration_dates.pos_inactive) ? 'error--text' : ''"
          >
            {{ formatShortDate(subscription.expiration_dates.pos_inactive) }}
          </div>
          <div class="text-caption error--text mt-1">
            <span v-if="isDateExpired(subscription.expiration_dates.pos_inactive)">{{
              translations.expired[lang]
            }}</span>
          </div>
        </b-card>
      </v-col>

      <!-- No SMS POS Card -->
      <v-col v-if="subscription.expiration_dates.no_sms_pos" cols="12" sm="6" md="3">
        <b-card
          hide-title
          hide-default-footer
          :color="
            isDateExpired(subscription.expiration_dates.no_sms_pos)
              ? 'error lighten-5'
              : 'grey lighten-4'
          "
          :style="{
            borderLeft: isDateExpired(subscription.expiration_dates.no_sms_pos)
              ? '4px solid #ff5252'
              : '4px solid #9e9e9e',
          }"
          elevation="3"
          class="pa-2 expiration-card"
        >
          <div
            class="text-caption font-weight-medium mb-1"
            :class="
              isDateExpired(subscription.expiration_dates.no_sms_pos)
                ? 'error--text'
                : 'grey--text text--darken-2'
            "
          >
            {{ translations.noSmsPosLabel[lang] }}
          </div>
          <div
            class="text-body-1 font-weight-bold"
            :class="isDateExpired(subscription.expiration_dates.no_sms_pos) ? 'error--text' : ''"
          >
            {{ formatShortDate(subscription.expiration_dates.no_sms_pos) }}
          </div>
          <div class="text-caption error--text mt-1">
            <span v-if="isDateExpired(subscription.expiration_dates.no_sms_pos)">{{
              translations.expired[lang]
            }}</span>
          </div>
        </b-card>
      </v-col>

      <v-col v-if="subscription.expiration_dates.campaigns_inactive" cols="12" sm="6" md="3">
        <b-card
          hide-title
          hide-default-footer
          :color="
            isDateExpired(subscription.expiration_dates.campaigns_inactive)
              ? 'error lighten-5'
              : 'grey lighten-4'
          "
          :style="{
            borderLeft: isDateExpired(subscription.expiration_dates.campaigns_inactive)
              ? '4px solid #ff5252'
              : '4px solid #9e9e9e',
          }"
          elevation="3"
          class="pa-2 expiration-card"
        >
          <div
            class="text-caption font-weight-medium mb-1"
            :class="
              isDateExpired(subscription.expiration_dates.campaigns_inactive)
                ? 'error--text'
                : 'grey--text text--darken-2'
            "
          >
            {{ translations.campaignsInactiveLabel[lang] }}
          </div>
          <div
            class="text-body-1 font-weight-bold"
            :class="
              isDateExpired(subscription.expiration_dates.campaigns_inactive) ? 'error--text' : ''
            "
          >
            {{ formatShortDate(subscription.expiration_dates.campaigns_inactive) }}
          </div>
          <div class="text-caption error--text mt-1">
            <span v-if="isDateExpired(subscription.expiration_dates.campaigns_inactive)">{{
              translations.expired[lang]
            }}</span>
          </div>
        </b-card>
      </v-col>
    </v-col>

    <v-sheet class="pa-3" :class="{ 'mx-3': tabsWithMargin }">
      <v-tabs v-model="tab" color="secondary" :vertical="$vuetify.breakpoint.mdAndDown" show-arrows>
        <v-tab
          v-for="tab in tabs"
          :key="tab.name['en']"
          v-text="tab.name[lang]"
          :to="tab.to"
          class="text-capitalize text-left text-md-center justify-start justify-md-center px-3"
        ></v-tab>
      </v-tabs>
    </v-sheet>

    <v-tabs-items v-model="tab" class="mt-3" style="background: transparent">
      <router-view></router-view>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import translations from '@/utils/translations/general/settings/billingDashboard';

export default {
  name: 'BillingDashboard',

  mixins: [translations],

  data() {
    return {
      tab: this.$route.path,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'superUser', 'panelType']),

    ...mapState('general/settings/billingDashboard/current', [
      'subscription',
      'subscriptionPlan',
      'currentBilling',
    ]),

    ...mapState('general/settings/billingDashboard/paymentMethods', ['selectedMethod']),

    lang() {
      return this.$route.params.lang;
    },

    permission() {
      return (
        this.superUser ||
        (this.$store.state.permissions.general_settings
          ? this.$store.state.permissions.general_settings.billing_dashboard.read
          : null)
      );
    },

    tabs() {
      let arr = [];

      arr.push({
        name: { el: 'Τρέχων', en: 'Current', it: 'Attuale' },
        to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/current`,
      });

      arr.push({
        name: { el: 'Μέθοδοι πληρωμής', en: 'Payment Methods', it: 'Modalità di pagamento' },
        to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/payment-methods`,
      });

      arr.push({
        name: { el: 'Ιστορικό πληρωμών', en: 'Payment History', it: 'Storico dei pagamenti' },
        to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/payment-history`,
      });

      arr.push({
        name: { el: 'Ειδοποιήσεις Email', en: 'Email Notifications', it: 'Notifiche via e-mail' },
        to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/email-notifications`,
      });

      return arr;
    },

    tabsWithMargin() {
      return this.$route.path === `/${this.lang}/${this.panelType}/settings/profile`;
    },

    announcement() {
      let announcement = {
        active: false,
        texts: [],
      };
      if (this.subscription && this.subscription.method_chosen === false) {
        announcement.active = true;
        announcement.texts = [
          { value: this.translations.choosePaymentMethodError1 || {} },
          {
            value: this.translations.choosePaymentMethodError2 || {},
            href: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/payment-methods`,
          },
          { value: this.translations.choosePaymentMethodError3 || {} },
        ];
        announcement.textColor = 'black';
        announcement.color = 'error';
      } else if (this.selectedMethod && !this.selectedMethod.status.includes('ok')) {
        announcement.active = true;
        announcement.texts = [
          { value: this.translations[`methodStatus_${this.selectedMethod.status}`] || {} },
        ];
        announcement.description =
          this.translations[`methodStatus_description_${this.selectedMethod.status}`];
        announcement.textColor = 'black';
        announcement.color = 'error';
      }

      return announcement;
    },
  },

  methods: {
    ...mapMutations(['setDeleteDialog', 'setNotification', 'setLoading']),
    ...mapActions('general/settings/billingDashboard', ['fetchBillingDashboardData']),

    formatShortDate(date) {
      if (!date) return '';
      const locale = this.lang === 'el' ? 'el-GR' : this.lang === 'it' ? 'it-IT' : 'en-GB';
      return new Date(date).toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },

    isDateExpired(date) {
      if (!date) return false;
      const expirationDate = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return expirationDate < today;
    },
  },

  watch: {
    permission: {
      // immediate: true,
      handler(val) {
        if (!val && !this.superUser) {
          this.$router.replace(`/${this.lang}/${this.panelType}/forbidden-gateway`);
        }
      },
    },
  },

  mounted() {
    this.fetchBillingDashboardData();
    if (this.$route.name == 'BillingDashboard') {
      this.$router.replace({
        path: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard/current`,
      });
    }
  },
};
</script>
<style>
.relative {
  position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
  width: 100%;
}

.v-tabs-bar.v-item-group > * {
  width: 100%;
}

.v-slide-group__content {
  width: 100%;
}
.expiration-card {
  min-height: 120px;
}
</style>
